import Header from 'chameleon/ui-stack/ui/page/header';
import { REPORTS_LABEL } from 'chameleon-src/components/SidebarWrapperTwoLevels/constants';
import CSPBanner from 'chameleon/legacy/src/components/apstudent/handlers/Assignments/CSPBanner';
import {
  getAssessments,
  tagsFromData,
  tagsWithAssessmentKeys,
  TrendDataFilterHelper,
  getAssignmentsIdsFromData,
} from 'chameleon/src/components/TrendReportingContainer/utils';
import { connect } from 'react-redux';
import { compose, withApollo } from 'react-apollo';
import { withCourseOutline } from 'chameleon-packages/units';
import { withRedux } from 'chameleon/legacy/src/components/assessment/Results/RelatedData/RelatedVideos/wrappers/';
import VideoResourcePreviewWrapper from 'chameleon-src/components/VideoResourcePreviewWrapper';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import cn from 'classnames';
import { getTrendData } from './client';
import TrendReportTable, { showRow } from './Table';
import PerformanceFilters from './Filters/components/PerformanceFilters';
import Filters from './Filters';
import Tabs from './Tabs';
import React, { useEffect, useState } from 'react';
import './styles.scss';
import GeneratePracticeQuizModal from './GeneratePracticeQuizModal';
import PracticeQuizSummaryModal from './Modals/PracticeQuizSummaryModal';
import GeneratePracticeQuizSuccessModal from './Modals/GeneratePracticeQuizSuccessModal';

const TrendReportingContainer = (props) => {
  const getSubjects = () => {
    const {
      userData: { isCoordinator, isAdmin, adminSubjects },
      userSubjects,
    } = props;

    if (isCoordinator || isAdmin) {
      return adminSubjects;
    }

    return userSubjects;
  };

  const {
    router,
    courseOutline,
    immediateFeedbackFlag,
    generatePracticeFlag,
    client,
    isStudent,
    educationPeriod,
    subjectInfo,
  } = props;
  const { currentEducationPeriod } = educationPeriod;
  const { id: currentEducationPeriodId } = currentEducationPeriod;
  const { subject: subjectId } = router.params;
  const subjects = getSubjects();
  const subjectInitId =
    !isStudent &&
    subjects.find(
      ({ masterSubjectId }) =>
        parseInt(masterSubjectId, 10) === parseInt(subjectId, 10),
    ).initId;
  const { pathname, query } = router.location;
  const { type: assessmentTypeParam } = query;

  const [data, setData] = useState([]);
  const [trendRawData, setTrendRawData] = useState([]);
  const [assignmentsIds, setAssignmentsIds] = useState([]); // The list of all assignments ids included in the trend data
  const [tags, setTags] = useState([]);
  const [assessmentData, setAssessmentData] = useState([]);
  const [assessmentsLoading, setAssessmentsLoading] = useState(true);
  const [firstDate, setFirstDate] = useState('');
  const [lastDate, setLastDate] = useState('');
  const [filterParamsData, setFilterParamsData] = useState({});
  const [generateQuizParameters, setGenerateQuizParameters] = useState({});
  const [checkedItems, setCheckedItems] = useState({
    notAssessed: true,
    firstQuartile: true,
    secondQuartile: true,
    thirdQuartile: true,
    fourthQuartile: true,
  });
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedAcademicYear, setSelectedAcademicYear] = useState(null);
  const [generatePracticeQuizModalOpen, setGeneratePracticeQuizModalOpen] =
    useState(false);

  const [isPracticeQuizSummaryVisible, setIsPracticeQuizSummaryVisible] =
    useState(false);
  const [createQuizSuccessData, setCreateQuizSuccessData] = useState({
    isModalVisible: false,
    itemId: '',
  });

  const [selectedSectionName, setSelectedSectionName] = useState('');
  const [selectedStudentName, setSelectedStudentName] = useState('');

  const [sortedLabels, setSortedLabels] = useState([]);
  useEffect(() => {
    if (trendRawData && trendRawData.length > 1) {
      const filteredTrendData = TrendDataFilterHelper.filterByAssessmentType(
        trendRawData,
        assessmentTypeParam,
      );
      setData(filteredTrendData);
    }
  }, [assessmentTypeParam]);

  useEffect(() => {
    if (!data) {
      setTags([]);
      setFirstDate('');
      setLastDate('');
      setAssessmentData([]);
      setAssignmentsIds([]);
      return;
    }
    const {
      assessments,
      firstDate: assesmentsFirstDate,
      lastDate: assessmentsLastDate,
    } = getAssessments(data);
    setFirstDate(assesmentsFirstDate);
    setLastDate(assessmentsLastDate);
    setAssessmentData(assessments);
    setTags(tagsWithAssessmentKeys(tagsFromData(data)));
    setAssignmentsIds(getAssignmentsIdsFromData(data));
  }, [data]);

  const fetchTrendData = (fetchedFiltersParamsData) => {
    if (fetchedFiltersParamsData.tagCategoryId) {
      setAssessmentsLoading(true);
      getTrendData(fetchedFiltersParamsData).then((responseData) => {
        setAssessmentsLoading(false);
        const filteredTrendData = TrendDataFilterHelper.filterByAssessmentType(
          responseData,
          assessmentTypeParam,
        );
        setData(filteredTrendData);
        setTrendRawData(responseData);
        setFilterParamsData(fetchedFiltersParamsData);
      });
    }
  };

  const updateAssessmentTypeParams = (assessmentType) => {
    router.push({
      pathname,
      query: {
        ...query,
        type: assessmentType,
      },
    });
  };

  const openVideo = (videoUrl) => {
    router.push({
      pathname,
      query: {
        ...query,
        apd: videoUrl,
      },
    });
  };
  const hiddenLabels = (
    tags?.filter((tag) => showRow(tag.percentage, checkedItems)) || []
  ).map((tag) => tag.label);

  return (
    <div className="report-container">
      <div className="grid justify-center">
        <Header
          subtitle={REPORTS_LABEL}
          title="Content &amp; Skills Performance"
        />
        {props.isStudent && <CSPBanner subject={subjectId} path="csp-report" />}
        <Filters
          fetchTrendData={fetchTrendData}
          subjectId={subjectId}
          setSelectedCurrCategory={setSelectedCategory}
          router={router}
          updateAssessmentTypeParams={updateAssessmentTypeParams}
          checkedItems={checkedItems}
          setCheckedItems={setCheckedItems}
          courseOutline={courseOutline}
          setSelectedAcademicYear={setSelectedAcademicYear}
          setSelectedSectionName={setSelectedSectionName}
          setSelectedStudentName={setSelectedStudentName}
        />
      </div>
      <div
        className={cn('flex justify-between mb-hide', {
          'border-bottom': !isStudent && generatePracticeFlag,
        })}
      >
        <Tabs
          defaultTab={assessmentTypeParam}
          onTabChange={updateAssessmentTypeParams}
        />
        {generatePracticeFlag && !isStudent && (
          <div className="flex items-center">
            <ButtonWithIcon
              icon="practice_quiz"
              isNaked
              onClick={() => setGeneratePracticeQuizModalOpen(true)}
              className={cn('border', 'rounded-20', 'px-4 py-2', {
                'border-gray-400 text-gray-600':
                  assessmentsLoading ||
                  !assessmentData ||
                  !assessmentData.length ||
                  !tags.some(({ percentage }) => percentage < 100), // if all tags are 100% or NaN then disable button,
                'border-blue-600 text-blue-600':
                  !assessmentsLoading &&
                  assessmentData &&
                  assessmentData.length,
              })}
              disabled={
                assessmentsLoading ||
                !assessmentData ||
                !assessmentData.length ||
                !tags.some(({ percentage }) => percentage < 100) // if all tags are 100% or NaN then disable button
              }
            >
              Generate Practice Quiz
            </ButtonWithIcon>
          </div>
        )}
      </div>
      <div className="mb-hide">
        <PerformanceFilters
          checkedItems={checkedItems}
          setCheckedItems={setCheckedItems}
        />
      </div>
      {immediateFeedbackFlag && !assessmentsLoading && !!assessmentData && (
        <div className="immediate-feedback-wrapper text-gray-600">
          <Icon name="immediate_feedback" />{' '}
          <label>
            Results DO NOT include assignments with immediate feedback ON
          </label>
        </div>
      )}
      <TrendReportTable
        checkedItems={checkedItems}
        tags={tags}
        assessments={assessmentData}
        firstDateScored={firstDate}
        lastDateScored={lastDate}
        loading={assessmentsLoading}
        selectedCategoryLabel={selectedCategory}
        paramsData={filterParamsData}
        courseOutline={courseOutline}
        openVideo={openVideo}
        subjectId={subjectId}
        educationPeriod={selectedAcademicYear}
        setSortedLabels={setSortedLabels}
        assignmentsIds={assignmentsIds}
      />
      {query.apd && (
        <VideoResourcePreviewWrapper
          sortedLabels={sortedLabels.filter(
            (label) => hiddenLabels.indexOf(label) > -1,
          )}
          category={selectedCategory}
        />
      )}
      {!props.isStudent && generatePracticeQuizModalOpen && (
        <GeneratePracticeQuizModal
          tags={tags}
          setGeneratePracticeQuizModalOpen={setGeneratePracticeQuizModalOpen}
          setGenerateQuizParameters={setGenerateQuizParameters}
          setIsPracticeQuizSummaryVisible={setIsPracticeQuizSummaryVisible}
          generateQuizParameters={generateQuizParameters}
          selectedCategory={selectedCategory}
          subjectId={subjectInitId}
          educationPeriod={currentEducationPeriodId}
          selectedSectionName={selectedSectionName}
          selectedStudentName={selectedStudentName}
        />
      )}
      <PracticeQuizSummaryModal
        isVisible={isPracticeQuizSummaryVisible}
        client={client}
        setIsModalVisible={setIsPracticeQuizSummaryVisible}
        setGeneratePracticeQuizModalOpen={setGeneratePracticeQuizModalOpen}
        tagCategoryId={filterParamsData.tagCategoryId}
        generatePracticeParams={generateQuizParameters}
        masterSubjectId={subjectId}
        subjectInfo={subjectInfo}
        setCreateQuizSuccessData={setCreateQuizSuccessData}
      />
      <GeneratePracticeQuizSuccessModal
        isVisible={createQuizSuccessData.isModalVisible}
        setCreateQuizSuccessData={setCreateQuizSuccessData}
        itemId={createQuizSuccessData.itemId}
      />
    </div>
  );
};

const mapStateToProps = ({ userData, userSubjects, subject, featureFlag }) => {
  const {
    immediate_feedback: immediateFeedbackFlag,
    generate_practice_quiz: generatePracticeFlag,
  } = featureFlag;
  return {
    userData,
    userSubjects,
    teacherSubjects: userData.teacherSubjects,
    subjectInfo: subject.data,
    isStudent: userData.isStudent,
    educationPeriod: userData.educationPeriod,
    immediateFeedbackFlag,
    generatePracticeFlag,
  };
};

export default compose(
  withApollo,
  withRedux,
  withCourseOutline(),
  connect(mapStateToProps, {}),
)(TrendReportingContainer);
